import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class SelectionPoolSpecs {
    @JsonProperty("pool_id")
    poolId: number = 0;

    @JsonProperty("sub_pool_id")
    subPoolId?: number;

    constructor(poolId: number, subPoolId?: number) {
        this.poolId = poolId;
        this.subPoolId = subPoolId;
    }
}
